<div class="ds-result" *ngIf="result">
  <div class="alert" [ngClass]="errors.length ? 'alert-danger' : (result.saved ? 'alert-success' : 'alert-info')">
    <b>{{result.message}}</b>
    <span *ngIf="result.sheetName"> &nbsp;·&nbsp; sheet "{{result.sheetName}}", {{result.rows}} rows</span>
  </div>
  <div class="ds-counts" *ngIf="!errors.length">
    <ng-container *ngFor="let c of counts">
      <span class="ds-count" *ngIf="result[c.field] != null && result[c.field] !== ''">{{c.label}}: <b>{{show(result[c.field])}}</b></span>
    </ng-container>
  </div>
  <div *ngIf="errors.length || notes.length" class="margin-bottom-10">
    <a href="javascript:;" (click)="download()"><i class="fa fa-download"></i> Download the list ({{errors.length}} problems, {{notes.length}} notes)</a>
  </div>
  <p-table *ngIf="errors.length" [value]="errors" [paginator]="errors.length > 10" [rows]="10" styleClass="ds-issues">
    <ng-template pTemplate="header"><tr><th style="width:70px">Row</th><th style="width:180px">Code</th><th>Problem</th></tr></ng-template>
    <ng-template pTemplate="body" let-e><tr><td>{{e.row || ''}}</td><td>{{e.code}}</td><td>{{e.message}}</td></tr></ng-template>
  </p-table>
  <div *ngIf="notes.length" class="margin-top-10">
    <b>Notes</b>
    <p-table [value]="notes" [paginator]="notes.length > 5" [rows]="5" styleClass="ds-issues">
      <ng-template pTemplate="body" let-e><tr><td style="width:70px">{{e.row || ''}}</td><td style="width:180px">{{e.code}}</td><td>{{e.message}}</td></tr></ng-template>
    </p-table>
  </div>
  <div *ngIf="prices.length && !errors.length" class="margin-top-10">
    <b>Prices used</b>
    <p-table [value]="prices" [paginator]="prices.length > 8" [rows]="8" styleClass="ds-issues">
      <ng-template pTemplate="header"><tr><th>Month</th><th>Item</th><th class="text-right">Price</th><th>From</th></tr></ng-template>
      <ng-template pTemplate="body" let-p><tr><td>{{p.month}}</td><td>{{p.item}}</td><td class="text-right">{{p.price | number:'1.2-2'}}</td><td>{{p.source}}</td></tr></ng-template>
    </p-table>
  </div>
</div>
